import type { ReasonOption } from '../../../project_starburst';

export const REASON_COLUMNS = 'Key,Reason,Show';

export function parseReasonRows(rows: readonly Record<string, unknown>[]): ReasonOption[] {
  const out: ReasonOption[] = [];
  const seen = new Set<string>();
  for (const row of rows) {
    const label = typeof row.Reason === 'string' ? row.Reason.trim() : '';
    if (label.length === 0) continue;
    const key = row.Key == null ? '' : String(row.Key).trim();
    if (key.length === 0 || seen.has(key)) continue;
    seen.add(key);
    const show = typeof row.Show === 'string' ? row.Show.trim().toLowerCase() : '';
    out.push({ key, label, show: show === 'pill' || show === 'default' ? 'pill' : 'list' });
  }
  return out;
}
